import { SubscriptionEntitlement } from '~/api/graphql';
import { useEntitlements } from '~/components/entitlements';

/**
 * True when the agency has the VISIBILITY_CONTROL entitlement (Pro+ tier).
 * Reads from EntitlementsContext, which is mounted inside the dashboard's
 * Suspense/Await for the agency-user loader — no inline fetch and no race
 * with the deferred route loader.
 */
export const useVisibilityEntitlement = (): boolean => {
  const { hasEntitlement } = useEntitlements();
  return hasEntitlement(SubscriptionEntitlement.VisibilityControl);
};

/**
 * True when the agency has the TEAM_MANAGEMENT entitlement (Enterprise tier).
 */
export const useTeamManagementEntitlement = (): boolean => {
  const { hasEntitlement } = useEntitlements();
  return hasEntitlement(SubscriptionEntitlement.TeamManagement);
};

/**
 * True when the agency has the AGENCY_PROFILE_MANAGEMENT entitlement (Enterprise tier).
 */
export const useAgencyProfileManagementEntitlement = (): boolean => {
  const { hasEntitlement } = useEntitlements();
  return hasEntitlement(SubscriptionEntitlement.AgencyProfileManagement);
};

/**
 * True when the agency has the AMS_CRM_INTEGRATIONS entitlement (Standard and above).
 */
export const useAmsCrmIntegrationsEntitlement = (): boolean => {
  const { hasEntitlement } = useEntitlements();
  return hasEntitlement(SubscriptionEntitlement.AmsCrmIntegrations);
};
